// @ts-check
import React from "react";
import moment from "moment";
import { useMainContext } from "../MainContext";

import Iconos from "../ClasesFunsiones/Iconos";
import StudyItem from "../../../models/studies/list";

export function Fechas() {
  const { state, dispatch } = useMainContext();
  const fechas = state.filtros.fechas;

  let CH = [false, false, false, false, false];
  switch (
    moment(fechas.final, "YYYYMMDD").diff(
      moment(fechas.inicio, "YYYYMMDD"),
      "d",
    )
  ) {
    case 1:
      CH[0] = true;
      break;
    case 7:
      CH[1] = true;
      break;
    case 30:
      CH[2] = true;
      break;
    case 365:
      CH[3] = true;
      break;
    default:
      CH[4] = true;
      break;
  }
  
  /** @param {number} dias */
  let cambiarfecha = (dias) => {
    dispatch({ type: 'SET_FECHAS', payload: {
      inicio: moment().subtract(dias, "d").format("YYYYMMDD"),
      final: moment().format("YYYYMMDD"),
    }});
  };
  
  /** @param {any} e */
  let cambiarrango = (e) => {
    let a = { ...fechas };
    a[e.target.name] = moment(e.target.value, "YYYY-MM-DD").format("YYYYMMDD");
    dispatch({ type: 'SET_FECHAS', payload: a });
  };
  return (
    <div className="CajaFechas">
      <div className="CajaFechas1">
        <BtnFecha
          onClick={() => {
            cambiarfecha(1);
          }}
          texto="dia"
          Check={CH[0]}
        />
        <BtnFecha
          onClick={() => {
            cambiarfecha(7);
          }}
          texto="semana"
          Check={CH[1]}
        />
        <BtnFecha
          onClick={() => {
            cambiarfecha(30);
          }}
          texto="mes"
          Check={CH[2]}
        />
        <BtnFecha
          onClick={() => {
            cambiarfecha(365);
          }}
          texto="año"
          Check={CH[3]}
        />
        <BtnFecha texto="rango" Check={CH[4]} onClick={() => {}} />
      </div>
      <div className="CajaFechas2">
        <label htmlFor="Finicio">Inicio</label>
        <input
          name="inicio"
          type="date"
          id="Finicio"
          onChange={cambiarrango}
          value={moment(fechas.inicio, "YYYYMMDD").format("YYYY-MM-DD")}
        />
        <label htmlFor="Ffinal">final</label>
        <input
          name="final"
          type="date"
          id="Ffinal"
          onChange={cambiarrango}
          value={moment(fechas.final, "YYYYMMDD").format("YYYY-MM-DD")}
        />
      </div>
    </div>
  );
}

export function FiltroModalidades() {
  const { state } = useMainContext();
  let comp;
  if (state.estudios.cargando) {
    comp = "Cargando....";
  }
  if (state.estudios.error) {
    comp = "Error....";
  }
  if (!state.estudios.cargando && !state.estudios.error) {
    comp = <Modlista />;
  }
  return <div className="FiltroModalidades">{comp}</div>;
}

const Modlista = () => {
  const { state, dispatch } = useMainContext();
  const filtromod = state.filtros.mod;
  const ListaEstudios = state.estudios;

  /** @param {string} e */
  let filtrar = (e) => {
    let a = [...filtromod];
    if (a.indexOf(e) > -1) {
      a.splice(a.indexOf(e), 1);
    } else {
      a.push(e);
    }
    dispatch({ type: 'SET_FILTRO_MOD', payload: a });
  };
  let modalidades = [];
  let a = [];
  for (let index = 0; index < ListaEstudios.items.length; index++) {
    const element = ListaEstudios.items[index];
    if (modalidades.indexOf(element.getModality()) === -1) {
      modalidades.push(element.getModality());
      a.push(element.getModalityText());
    }
  }
  let Btn = [];
  for (let index = 0; index < a.length; index++) {
    Btn.push(
      <BtnFecha
        key={index}
        texto={a[index]}
        Check={filtromod.indexOf(modalidades[index]) === -1}
        onClick={() => {
          filtrar(modalidades[index]);
        }}
      />,
    );
  }
  let todo = () => {
    let b = [];
    if (filtromod.length === 0) {
      b = modalidades;
    }
    dispatch({ type: 'SET_FILTRO_MOD', payload: b });
  };
  return (
    <>
      <BtnFecha
        texto="todos"
        Check={filtromod.length === 0}
        onClick={todo}
      />
      {Btn}
    </>
  );
};

export function Setting() {
  const { state, dispatch } = useMainContext();
  const autoSync = state.configuracion?.autoSync ?? true;

  let cambiarAutoSync = () => {
    dispatch({ type: 'SET_AUTOSYNC', payload: !autoSync });
  };
  return (
    <div className="Setting">
      <BtnFecha
        texto="auto sync"
        Check={autoSync}
        onClick={cambiarAutoSync}
      />
    </div>
  );
}

/**
 * @param {Object} props
 * @param {boolean} props.Check
 * @param {string} props.texto
 * @param {import("react").MouseEventHandler<HTMLButtonElement>} [props.onClick]
 */
let BtnFecha = (props) => {
  let check = props.Check ? "check activo" : "check";
  return (
    <div className="btncontenedor">
      <button className="Boton" onClick={props.onClick}>
        {props.texto}
      </button>
      <div className={check}>
        <Iconos icon="done" color="white" />
      </div>
    </div>
  );
};
